import { defineComponent as l, openBlock as a, createBlock as r, unref as p, mergeProps as c, withCtx as i, createElementVNode as t } from "vue";
import { RevIcon as u } from "@ds/components/Icon";
const f = /* @__PURE__ */ l({
  name: "IconQuality",
  __name: "IconQuality",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const n = o;
    return (m, e) => (a(), r(p(u), c(n, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        t("path", { d: "M17.53 8.54a.75.75 0 0 0-1.06-1.061L11 12.949l-2.47-2.47a.75.75 0 0 0-1.06 1.06l2.646 2.647a1.25 1.25 0 0 0 1.768 0l5.646-5.647" }, null, -1),
        t("path", {
          "fill-rule": "evenodd",
          d: "M4.5 2.759a1.25 1.25 0 0 0-1.25 1.25V8.73c0 9.392 7.29 12.1 8.395 12.455a1.15 1.15 0 0 0 .71 0C13.46 20.83 20.75 18.122 20.75 8.73V4.01a1.25 1.25 0 0 0-1.25-1.25h-15m.25 5.97V4.26h14.5v4.47c0 8.106-6.024 10.573-7.25 10.992-1.226-.419-7.25-2.886-7.25-10.992",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
